// extracted by mini-css-extract-plugin
export default {"brandPromo":"bF-z","carousel":"cF-z"};